<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  indeterminate: { type: Boolean, default: false }
})
const emit = defineEmits(['update:modelValue']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  }
})
</script>

<script>
export default {
  inheritAttrs: false,
  name: "DpCheckbox"
}
</script>

<template>
  <label class="dp-checkbox">
    <span class="dp-checkbox__box"
          :class="{'checked': value, 'indeterminate': props.indeterminate}"></span>
    <input v-bind="$attrs" type="checkbox" v-model="value"/>
    <slot></slot>
  </label>
</template>

<style lang="scss">
.dp-checkbox {
  position: relative;
  cursor: pointer;
  font-size: 1em;
  padding-left: 1.5em;
  border-radius: 8px;

  &:hover {
    input:before {
      border-color: var(--application-color);
    }
  }

  input {
    display: none;
  }

  .dp-checkbox__box {
    height: 0;
    width: 0;
    font-size: 1em;

    &:before {
      content: '';
      position: absolute;
      top: 0.2em;
      left: 0;
      height: 0.8em;
      width: 0.8em;
      border-radius: 4px;
      border: 2px var(--use-theme__font-color) solid;
    }

    &:after {
      content: '';
      position: absolute;
      display: none;
      left: 0.33em;
      top: 0.3em;
      width: 0.2em;
      height: 0.5em;
      border: solid white;
      border-width: 0 .18em .18em 0;
    }

    &.checked {
      &:before {
        background-color: var(--application-color);
        border-color: var(--application-color);
      }

      &:after {
        display: block;
        transform: rotate(45deg);
      }

      &.indeterminate:after {
        transform: rotate(90deg);
        left: 0.4em;
        top: 0.35em;
        width: 0;
        height: 0.5em;
      }
    }
  }
}

</style>